<div class="one" fxLayout="column" [formGroup]="matterLeasingForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
      <mat-label>Annual Rental</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        matTooltip="{{ toolTipList ? toolTipList.ANNUALRENTAL?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ANNUALRENTAL"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.ANNUALRENTAL) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.ANNUALRENTAL.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.ANNUALRENTAL?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
      <mat-label>Annual Rental Clause</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        matTooltip="{{ toolTipList ? toolTipList.ANNUALRENTALCLAUSE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ANNUALRENTALCLAUSE"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.ANNUALRENTALCLAUSE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.ANNUALRENTALCLAUSE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.ANNUALRENTALCLAUSE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
      <mat-label>Rental Amount</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        matTooltip="{{ toolTipList ? toolTipList.RENTALAMOUNT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="RENTALAMOUNT"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.RENTALAMOUNT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.RENTALAMOUNT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.RENTALAMOUNT?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
      <mat-label>Per</mat-label>
      <mat-select formControlName="RENTALPERIOD">
        <mat-option value="Week">Week</mat-option>
        <mat-option value="Month">Month</mat-option>
        <mat-option value="Quarter">Quarter</mat-option>
        <mat-option value="Year">Year</mat-option>
      </mat-select>
      @if (testBool && toolTipList.RENTALPERIOD) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.RENTALPERIOD.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.RENTALPERIOD?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-checkbox fxFlex="33" class="pr-1" formControlName="GSTPAYABLE">GST Payable</mat-checkbox>
    <mat-form-field appearance="outline" class="example" fxFlex="33" class="pr-1">
      <mat-label>Rent Payable On What Day</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.RENTPAYABLEONWHATDAY?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="RENTPAYABLEONWHATDAY"
      />
      @if (testBool && toolTipList.RENTPAYABLEONWHATDAY) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.RENTPAYABLEONWHATDAY.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.RENTPAYABLEONWHATDAY?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="example" fxFlex="33" class="pr-1">
      <mat-label>Outgoings</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.OUTGOINGS?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="OUTGOINGS"
      />
      @if (testBool && toolTipList.OUTGOINGS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.OUTGOINGS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.OUTGOINGS?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
      <mat-label>Security Deposit</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        matTooltip="{{ toolTipList ? toolTipList.SECURITYDEPOSIT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="SECURITYDEPOSIT"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.SECURITYDEPOSIT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.SECURITYDEPOSIT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.SECURITYDEPOSIT?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
      <mat-label>Security Deposit Type</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.SECURITYDEPOSITTYPE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="SECURITYDEPOSITTYPE"
      />
      @if (testBool && toolTipList.SECURITYDEPOSITTYPE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.SECURITYDEPOSITTYPE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.SECURITYDEPOSITTYPE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
      <mat-label>Overdue Rent Int %</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.OVERDUERENTINTERESTRATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="OVERDUERENTINTERESTRATE"
      />
      @if (testBool && toolTipList.OVERDUERENTINTERESTRATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.OVERDUERENTINTERESTRATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.OVERDUERENTINTERESTRATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
      <mat-label>Rent Start Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'RENTSTARTDATE')"
        formControlName="RENTSTARTDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'RENTSTARTDATE')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList.RENTSTARTDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        name="RentStartDate"
        [matDatepicker]="RentStartDate"
      />
      <mat-datepicker-toggle matSuffix [for]="RentStartDate"></mat-datepicker-toggle>
      <mat-datepicker #RentStartDate></mat-datepicker>
      @if (testBool && toolTipList.RENTSTARTDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.RENTSTARTDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.RENTSTARTDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div class="group one" fxLayout="column">
    <h2>Rent Free</h2>
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
        <mat-label>Start Date</mat-label>
        <input
          (dateInput)="CommanDatePickerClick('input', $event, 'RENTFREESTARTDATE')"
          formControlName="RENTFREESTARTDATETEXT"
          (dateChange)="CommanDatePickerClick('input', $event, 'RENTFREESTARTDATE')"
          matInput
          matTooltip="{{ toolTipList ? toolTipList.RENTFREESTARTDATE?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          name="StartDate"
          [matDatepicker]="StartDate"
        />
        <mat-datepicker-toggle matSuffix [for]="StartDate"></mat-datepicker-toggle>
        <mat-datepicker #StartDate></mat-datepicker>
        @if (testBool && toolTipList.RENTFREESTARTDATE) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.RENTFREESTARTDATE.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.RENTFREESTARTDATE?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
        <mat-label>Clause</mat-label>
        <input
          matInput
          style="text-align: right"
          type="text"
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          matTooltip="{{ toolTipList ? toolTipList.RENTFREECLAUSE?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="RENTFREECLAUSE"
          [leadZero]="true"
        />
        @if (testBool && toolTipList.RENTFREECLAUSE) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.RENTFREECLAUSE.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.RENTFREECLAUSE?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
        <mat-label>Units</mat-label>
        <input
          matInput
          style="text-align: right"
          type="text"
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          matTooltip="{{ toolTipList ? toolTipList.RENTFREEUNITS?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="RENTFREEUNITS"
          [leadZero]="true"
        />
        @if (testBool && toolTipList.RENTFREEUNITS) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.RENTFREEUNITS.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList ? $safeNavigationMigration(toolTipList?.RENTFREEUNITS?.COPYVALUE) : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
        <mat-select formControlName="RENTFREEPERIOD">
          <mat-option value="Week">Week</mat-option>
          <mat-option value="Month">Month</mat-option>
          <mat-option value="Quarter">Quarter</mat-option>
          <mat-option value="Year">Year</mat-option>
        </mat-select>
        @if (testBool && toolTipList.RENTFREEPERIOD) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.RENTFREEPERIOD.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.RENTFREEPERIOD?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <mat-form-field appearance="outline" class="example" fxFlex="50" class="pr-1">
        <mat-label>Amount</mat-label>
        <input
          matInput
          style="text-align: right"
          type="text"
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          matTooltip="{{ toolTipList ? toolTipList.RENTFREEAMOUNT?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="RENTFREEAMOUNT"
          [leadZero]="true"
        />
        @if (testBool && toolTipList.RENTFREEAMOUNT) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.RENTFREEAMOUNT.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.RENTFREEAMOUNT?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="example" fxFlex="50" class="pr-1">
        <mat-label>Override Amount</mat-label>
        <input
          matInput
          style="text-align: right"
          type="text"
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          matTooltip="{{ toolTipList ? toolTipList.RENTFREEOVERRIDEAMOUNT?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="RENTFREEOVERRIDEAMOUNT"
          [leadZero]="true"
        />
        @if (testBool && toolTipList.RENTFREEOVERRIDEAMOUNT) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.RENTFREEOVERRIDEAMOUNT.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.RENTFREEOVERRIDEAMOUNT?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="group one" fxLayout="column">
    <h2>Public Liability Insurance</h2>
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
        <mat-label>Required Amount</mat-label>
        <input
          matInput
          style="text-align: right"
          type="text"
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          matTooltip="{{ toolTipList ? toolTipList.PUBLICLIABAMOUNT?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="PUBLICLIABAMOUNT"
          [leadZero]="true"
        />
        @if (testBool && toolTipList.PUBLICLIABAMOUNT) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.PUBLICLIABAMOUNT.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.PUBLICLIABAMOUNT?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
        <mat-label>Premium</mat-label>
        <input
          matInput
          style="text-align: right"
          type="text"
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          matTooltip="{{ toolTipList ? toolTipList.PUBLICLIABPREMIUM?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="PUBLICLIABPREMIUM"
          [leadZero]="true"
        />
        @if (testBool && toolTipList.PUBLICLIABPREMIUM) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.PUBLICLIABPREMIUM.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.PUBLICLIABPREMIUM?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
        <mat-label>Clause</mat-label>
        <input
          matInput
          style="text-align: right"
          type="text"
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          matTooltip="{{ toolTipList ? toolTipList.PUBLICLIABPREMIUMCLAUSE?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="PUBLICLIABPREMIUMCLAUSE"
          [leadZero]="true"
        />
        @if (testBool && toolTipList.PUBLICLIABPREMIUMCLAUSE) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.PUBLICLIABPREMIUMCLAUSE.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.PUBLICLIABPREMIUMCLAUSE?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="example" fxFlex="25" class="pr-1">
        <mat-label>Stamp Duty</mat-label>
        <input
          matInput
          style="text-align: right"
          type="text"
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          matTooltip="{{ toolTipList ? toolTipList.PUBLICLIABSTAMPDUTY?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="PUBLICLIABSTAMPDUTY"
          [leadZero]="true"
        />
        @if (testBool && toolTipList.PUBLICLIABSTAMPDUTY) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.PUBLICLIABSTAMPDUTY.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.PUBLICLIABSTAMPDUTY?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <mat-form-field appearance="outline" class="example" fxFlex="50" class="pr-1">
        <mat-label>Payable When?</mat-label>
        <input
          matInput
          matTooltip="{{ toolTipList ? toolTipList.PUBLICLIABPAYABLE?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="PUBLICLIABPAYABLE"
        />
        @if (testBool && toolTipList.PUBLICLIABPAYABLE) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.PUBLICLIABPAYABLE.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.PUBLICLIABPAYABLE?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="example" fxFlex="50" class="pr-1">
        <mat-label>Interest Of Lessor</mat-label>
        <input
          matInput
          style="text-align: right"
          type="text"
          mask="separator.2"
          thousandSeparator=","
          decimalMarker="."
          matTooltip="{{ toolTipList ? toolTipList.PUBLICLIABINTERESTOFLESSOR?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="PUBLICLIABINTERESTOFLESSOR"
          [leadZero]="true"
        />
        @if (testBool && toolTipList.PUBLICLIABINTERESTOFLESSOR) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.PUBLICLIABINTERESTOFLESSOR.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.PUBLICLIABINTERESTOFLESSOR?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
    </div>
  </div>
</div>
